// src/components/PontoReminderModal.jsx
import React from "react";
import { createPortal } from "react-dom";

const formatCampoLabel = (campo) =>
  String(campo || "")
    .replace(/([A-Z])/g, " $1")
    .trim();

export default function PontoReminderModal({
  open,
  alerta,
  registrando = false,
  onClose,
  onRemindLater,
  onRegistrar,
}) {
  if (!open || !alerta) return null;

  return createPortal(
    <div className="ponto-reminder-overlay">
      <div
        className="ponto-reminder-panel"
        role="dialog"
        aria-modal="true"
        aria-label="Lembrete de ponto pendente"
      >
        <div className="ponto-reminder-modal__icon">⏰</div>

        <h2>Você esqueceu de bater o ponto</h2>

        <p className="ponto-reminder-modal__text">
          Existe uma pendência de registro no seu cartão de ponto.
        </p>

        <div className="ponto-reminder-modal__highlight">
          <strong>{alerta.label}</strong>
          {alerta.previsto ? (
            <span>Horário previsto: {alerta.previsto}</span>
          ) : null}
        </div>

        <div className="ponto-reminder-modal__actions">
          <button
            type="button"
            className="btn primary ponto-reminder-modal__primary"
            onClick={() => onRegistrar?.(alerta.campo)}
            disabled={registrando}
          >
            {registrando
              ? "Registrando..."
              : `Registrar ${formatCampoLabel(alerta.campo)}`}
          </button>

          <button
            type="button"
            className="btn secondary"
            onClick={onRemindLater}
            disabled={registrando}
          >
            Lembrar novamente depois
          </button>

          
        </div>
      </div>
    </div>,
    document.body
  );
}